import React from 'react';
import { useUser } from '@/context/UserContext';
import '@/styles/Panels.css';

interface ReferralSystemProps {
    onClose: () => void;
}

const ReferralSystem: React.FC<ReferralSystemProps> = ({ onClose }) => {
    const { user } = useUser();
    const referralLink = `https://t.me/colourviewbot?startapp=${encodeURIComponent(user?.uid || '')}`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(referralLink);
        alert('Referral link copied to clipboard!');
    };

    return (
        <div className="panel referrals-panel">
            <div className="panel-header">
                <h2>Referral System</h2>
                <button className="close-button" onClick={onClose}>×</button>
            </div>
            <div className="panel-content">
                <p>Invite friends to ColourView and earn rewards!</p>
                <div className="referral-box">
                    <input type="text" readOnly value={referralLink} className="referral-input" />
                    <button onClick={copyToClipboard} className="copy-button">Copy Link</button>
                </div>
                <div className="stats-list">
                    <div className="stat-item">
                        <span>Referrals:</span>
                        <span>0</span>
                    </div>
                    <div className="stat-item">
                        <span>Rewards Earned:</span>
                        <span>0 Tokens</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReferralSystem;
